module.exports = __webpack_public_path__ + "img/eisen_snap.c6213afa.png";